<template>
  <v-card class="UserListItem" :class="{ 'is-header': header }" :flat="true"> <!-- @click="e => $emit('click', e)" -->
    <v-container class="user-list-item-container py-2 px-0" fluid>

      <v-row justify="space-between" align="center" no-gutters class="px-3">
        <v-col cols="auto">
          <slot name="avatar" />
        </v-col>

        <v-col cols="0">
          <div class="py-1 px-1 nowraptext">
            <slot name="name" />
          </div>
          <div class="py-1 px-1 nowraptext" style="opacity: 0.8;">
            <slot name="email" />
          </div>
        </v-col>

        <v-col cols="auto" style="min-width: 120px;">
          <slot name="usertype" />
        </v-col>
        <!--
        <v-col cols="auto" style="width: 50px;">
          <slot name="actions" />
        </v-col>
        -->
      </v-row>

    </v-container>

    <v-divider :style="'border-color: rgb(0 0 0 /' + (header ? 18 : 8) + '%);'" />
  </v-card>
</template>


<script>
export default {
  name: "UserListItemSlotTemplate",
  props: {
    header: Boolean,
  },
  components: {},

  data() {
    return {
    };
  },

  mounted() { },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped>
.UserListItem.deactivated {
  background-color: #f5f5f5;
}

.UserListItem:not(.deactivated) {
  background-color: white;
}

.UserListItem {
  color: rgba(0, 0, 0, 0.87);
  transition: background-color 120ms ease;
}

.UserListItem:not(.is-header):not(.deactivated):hover {
  background-color: #fafafa;
}

.UserListItem.is-header {
  background-color: #f7f9fc;
  color: rgba(0, 0, 0, 0.54);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.user-list-item-container {
  min-height: 58px;
}

.UserListItem.is-header .user-list-item-container {
  min-height: 42px;
}

.nowraptext {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
</style>